// /CoreWrapper/cores/coreGlow.js
/* eslint-disable react/prop-types */
import React from 'react'

const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : [])

export function coreGlow(BaseComponent) {
	const WithGlow = ({
		glow, // false | true | string | string[]
		glowColor,
		glowColors,
		glowHoverColor,
		glowHoverColors,
		glowIntensity = 'soft', // 'soft' | 'strong'
		glowHoverOnly = false,

		// box-shadow controls
		glowOffsetX, // Example: 0
		glowOffsetY, // Example: 0
		glowBlur, // Example: 18
		glowSpread, // Example: 0
		glowHoverOffsetX, // Example:
		glowHoverOffsetY,
		glowHoverBlur,
		glowHoverSpread,

		// transition controls
		glowTransition, // full CSS transition string
		glowTransitionDuration = '0.25s',
		glowTransitionTiming = 'ease',

		className = '',
		style = {},
		...rest
	}) => {
		if (!glow) {
			return (
				<BaseComponent className={className} style={style} {...rest} />
			)
		}

		// Base colors (can be: glow=true → default, string, array, or props)
		let baseList = toArray(glowColors || glowColor || glow)
		if (!baseList.length && glow === true) {
			baseList = ['#4846f4']
		}
		const baseColor = baseList[0] || '#4846f4'

		// Hover colors (fall back to base)
		const hoverListRaw = toArray(glowHoverColors || glowHoverColor)
		const hoverList = hoverListRaw.length > 0 ? hoverListRaw : baseList

		// Intensity defaults
		const defaultBlur = glowIntensity === 'strong' ? 28 : 18
		const defaultHoverBlur = glowIntensity === 'strong' ? 32 : 22

		// Base shadow params
		const x = glowOffsetX !== undefined ? glowOffsetX : 0
		const y = glowOffsetY !== undefined ? glowOffsetY : 0
		const blur = glowBlur !== undefined ? glowBlur : defaultBlur
		const spread = glowSpread !== undefined ? glowSpread : 0

		// Hover shadow params
		const hx = glowHoverOffsetX !== undefined ? glowHoverOffsetX : x
		const hy = glowHoverOffsetY !== undefined ? glowHoverOffsetY : y
		const hblur =
			glowHoverBlur !== undefined ? glowHoverBlur : defaultHoverBlur
		const hspread = glowHoverSpread !== undefined ? glowHoverSpread : spread

		// Multi-color box-shadows
		const effectiveBaseColors = baseList.length > 0 ? baseList : [baseColor]
		const effectiveHoverColors =
			hoverList.length > 0 ? hoverList : effectiveBaseColors

		const baseShadow = effectiveBaseColors
			.map((c) => `${x}px ${y}px ${blur}px ${spread}px ${c}`)
			.join(', ')

		const hoverShadow = effectiveHoverColors
			.map((c) => `${hx}px ${hy}px ${hblur}px ${hspread}px ${c}`)
			.join(', ')

		const transitionValue =
			glowTransition ||
			`box-shadow ${glowTransitionDuration} ${glowTransitionTiming}, transform ${glowTransitionDuration} ${glowTransitionTiming}`

		const classes = [
			'wbk-glow',
			`wbk-glow--${glowIntensity}`,
			glowHoverOnly && 'wbk-glow--hover-only',
			className
		]
			.filter(Boolean)
			.join(' ')

		const mergedStyle = {
			'--wbk-glow-shadow': baseShadow,
			'--wbk-glow-shadow-hover': hoverShadow,
			'--wbk-glow-transition': transitionValue,
			...style
		}

		return (
			<BaseComponent className={classes} style={mergedStyle} {...rest} />
		)
	}

	return WithGlow
}
